import { useCallback, useEffect, useState } from "react";

import { useSystemInformation } from '../hooks/useSystemInformation';

import { getInteractTemplateEnvironmentNoFiles } from "../api/interactTemplateEnvironment.js";
import { getClientInfo } from "../api/storage.js"

// A template or its environment group can be removed while the dashboard is open. The poll
// skips it; the default 404 handling would move the user to /not-found on the next tick.
const skipMissingTemplate = { statusCodeHandlers: [{ statusCode: 404, handler: () => {} }] };

export const getTemplateServerStatus = (templateId) =>
  getInteractTemplateEnvironmentNoFiles(templateId, skipMissingTemplate);


const interval = (delay = 0) => /** @param {() => void} callback */ (
  callback
) =>
  useEffect(() => {
    const id = setInterval(callback, delay);

    return () => clearInterval(id);
  }, [callback]);

const use60Second = interval(60000);

export const useUpdateServerStatusTimer = ({
  initiallyRunning = false
} = {}) => {
  const {hubClients, setHubClients} = useSystemInformation();
  // const [isFirst, setIsFirst] = useState(true);
  const [serverStatuses, setServerStatuses] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [running, setRunning] = useState(initiallyRunning);
  const [tickDate, setTickDate] = useState(null);

  const getHubClientInfo = useCallback(async () => {
    const [clients] = await Promise.all([getClientInfo()]);
    //console.log("useUpdateServerStatusTimer", "getHubClientInfo", "clients", clients);
    setHubClients(clients);
  });

  // ServerInformationProvider already loads the hub clients on mount, so this only stamps the date.
  useEffect(() => {
    setTickDate(Date.now());
  }, []);

  const tick = useCallback(
    async () => {
        setTickDate(Date.now());

        await getHubClientInfo();

        //console.log("useUpdateServerStatusTimer", "tick:", "templates", templates);
        if (!(templates?.length > 0))
          return;

        let statuses = [];
        await Promise.all(templates.map(async (template) => {
          try {
            const tpl = await getTemplateServerStatus(template.id);

            if (!!tpl?.servers)
            {
              const srvStatuses = tpl.servers.map(server => { return { id: server.serverId, name: server.name, enabled: server.enabled, status: server.status, statusMessage: server.statusMessage }; });

              if (srvStatuses?.length > 0)
              {
                statuses.push({template: template.id, statuses: srvStatuses, fileCount: tpl.fileCount});
              }
            }
          } catch (err) {
            console.log("useUpdateServerStatusTimer ERROR:", err);
          }
        }));

        //console.log("useUpdateServerStatusTimer", "tick:", "statuses", statuses);
        setServerStatuses(statuses);
      },
    [running]
  );

  const start = () => setRunning(true);
  const pause = () => setRunning(false);
  const reset = () => {
    setServerStatuses([]);
  };
  const stop = () => {
    pause();
    reset();
  };

  use60Second(tick);

  return { pause, reset, running, serverStatuses, setTemplates, hubClients, start, stop, tickDate };
};
